import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "../AdminAuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, signIn } = useAdminAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(username, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Sign-in failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0e] text-[#e9e6db] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <p className="font-serif-display italic text-5xl text-[#c3ba9e]">asvasa</p>
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#8c8a7e] mt-2">Atelier console</p>
        </div>

        <form
          onSubmit={submit}
          className="bg-[#161617] border border-[#2a2a2d] p-10 space-y-6"
        >
          <div>
            <label className="text-[10px] tracking-[0.32em] uppercase text-[#8c8a7e]">Username</label>
            <input
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-[#2a2a2d] focus:border-[#c3ba9e] outline-none py-2 text-[15px] text-[#e9e6db] placeholder:text-[#5e5d54] transition-colors"
              placeholder="shashank"
              data-testid="admin-login-username"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.32em] uppercase text-[#8c8a7e]">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-[#2a2a2d] focus:border-[#c3ba9e] outline-none py-2 text-[15px] text-[#e9e6db] placeholder:text-[#5e5d54] transition-colors"
              placeholder="••••••••••"
              data-testid="admin-login-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#c3ba9e] text-[#0d0d0e] py-4 text-[11px] tracking-[0.32em] uppercase font-medium hover:bg-[#FDFAF6] transition-colors disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <p className="text-center text-[11px] text-[#5e5d54] mt-8 tracking-wider">
          Restricted area · Authorised personnel only
        </p>
      </div>
    </div>
  );
}
